export default function SocialLinks() {
  const socialLinks = [
    {
      name: 'Instagram',
      icon: 'ri-instagram-line',
      url: 'https://www.instagram.com/elmoustachiobandito',
      color: 'hover:bg-pink-600'
    },
    {
      name: 'LinkedIn',
      icon: 'ri-linkedin-line',
      url: 'https://www.linkedin.com/in/estebansstach82',
      color: 'hover:bg-blue-700'
    },
    {
      name: 'Facebook',
      icon: 'ri-facebook-line',
      url: 'https://www.facebook.com/TheMoustachedBandit',
      color: 'hover:bg-blue-600'
    }
  ];

  return (
    <div>
      <h3 className="text-2xl font-bold mb-6 text-gray-900">Connect With Me</h3>
      <p className="text-gray-600 mb-6">
        Follow my work and stay updated with my latest projects on social media.
      </p>
      <div className="grid grid-cols-3 gap-4">
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex flex-col items-center justify-center p-6 bg-gray-100 rounded-xl transition-all ${social.color} hover:text-white group cursor-pointer`}
            aria-label={social.name}
          >
            <i className={`${social.icon} text-3xl mb-2`}></i>
            <span className="text-sm font-medium">{social.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
